
import { Anchor as uuiAnchor} from '@epam/uui-components';

export const Anchor = uuiAnchor;